import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, AlertController, ViewController, Loading, LoadingController } from 'ionic-angular';
import { UserModel } from '../../models/user/user.model';
import * as _ from "lodash";
import { UtilService } from "../../services/util.service";
import { ModalAction } from '../../enums/modalaction.enum';
import { UserService } from '../../services/user.service';

/**
 * Generated class for the ImpersonatePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-impersonate',
  templateUrl: 'impersonate.html',
})
export class ImpersonatePage {
  userList: UserModel[] = [];
  selectedUser: UserModel;
  otp: string;
  user_name: string;
  password: string;
  login: string;
  loading: Loading;

  constructor(
    public navCtrl: NavController
    , public navParams: NavParams
    , private util: UtilService
    , private alertCtrl: AlertController
    , private viewCtrl: ViewController
    , private userService: UserService
    , private loadingCtrl: LoadingController
  ) {
  }

  ngOnInit() {
  }

  ngOnDestroy() {
  }

  selectUser(value: UserModel) {
    this.selectedUser = value;
  }

  dismiss() {
    this.viewCtrl.dismiss({ action: ModalAction.Cancel });
  }
  
  proceed() {
    if (_.isEmpty(this.selectedUser)) {
      this.util.displayAlert(
        this.alertCtrl,
        "User not selected",
        "Please select a user"
      );
      return;
    }

    this.viewCtrl.dismiss({ action: ModalAction.Proceed, selectedUser: this.selectedUser });
  }

  getImpersonateList() {
    if (_.isEmpty(this.login)
        || _.isEmpty(this.otp)
        || _.isEmpty(this.user_name)
        || _.isEmpty(this.password)) {
      this.util.displayAlert(this.alertCtrl, "Missing input", "You need to fill all the input.");
      return;
    }

    this.loading = this.util.displayLoading(this.loading, this.loadingCtrl, "Loading data...")
    this.userService.getImpersonateList(this.login.trim(), this.otp, this.user_name, this.password).subscribe(
      (res) => {
        this.userList = res;
      }
      , (error) => {
        this.util.processError(this.loading, this.alertCtrl, error)
      }
      , () => {
        this.loading.dismiss();
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/impersonate/impersonate.ts